<template>
    <el-skeleton :rows="12" :loading="loading" animated>
        <template #default>
            <div class="text-center">
                <div>
                    Afiliado: <strong>{{ withdraw.affiliate?.user.name }}</strong>
                </div>
                <div>
                    Data do pedido: <strong>{{ new Date(withdraw.created_at ?? 0).toLocaleString() }}</strong>
                </div>
                <div>
                    Valor solicitado: <strong class="text-success">{{ withdraw.value.toFixed(2) }}MT</strong>
                </div>
                <div>
                    Conta a enviar: <strong class="text-primary">{{ withdraw.account }}</strong>
                </div>
                <div v-if="withdraw.transaction_id">
                    ID transa&ccedil;&atilde;o: <strong>{{ withdraw.transaction_id }}MT</strong>
                </div>
                <div class="p-2">
                    <span style="border-radius: 10px; display: inline-block;" class="p-3 py-1 text-light" :class="{'bg-success': withdraw.sent, 'bg-danger': !withdraw.sent}">
                        {{ withdraw.sent ? 'Enviado':'Pendente' }}
                    </span>
                </div>
            </div>
            <template v-if="!withdraw.sent">
                <el-divider />
                <el-form ref="formRef" :disabled="saving" label-position="top">
                    <el-form-item prop="title" label="ID da transacao">
                        <el-input name="title" type="text" v-model="transaction_id" @keypress="validate" />
                        <span class="text-danger small" v-if="error">{{ error }}</span>
                    </el-form-item>
    
                    <el-button plain :loading="saving" size="large" type="success" @click.prevent="submit">
                        Marcar como pago
                    </el-button>
                </el-form>
            </template>
        </template>
    </el-skeleton>
</template>

<script lang="ts" setup>
    import Api from "@/services/api"
    import { Withdraw } from "@/services/types/affiliate";
    import { ElDivider, ElMessage, FormInstance, FormRules } from "element-plus"
    import { reactive, ref } from "vue"

    const props = defineProps<{
        withdraw: Withdraw
    }>()
    const transaction_id = ref<string>('')

    // eslint-disable-next-line no-undef
    const emit = defineEmits<{
        update: [withdraw: Withdraw]
    }>()

    const saving = ref<boolean>(false)
    const loading = ref<boolean>(false)
    const error = ref<string | null>(null)

    const validate = () => {
        if (!transaction_id.value || transaction_id.value.trim().length <= 0) {
            error.value = 'Preencha o id da transacao'
            return;
        }

        error.value = null
    }
    const submit = async () => {
        if (!transaction_id.value || transaction_id.value.trim().length <= 0) {
            error.value = 'Preencha o id da transacao'
            return;
        }
        saving.value = true
        
        const res = await Api.post('admin/affiliates/deposit/' + props.withdraw.id, {transaction_id: transaction_id.value})
        console.log(res.data)
        if (res.status == 200) {
            ElMessage.success({message: 'Marcado como pago'})
            emit("update", res.data.withdraw)
        } else if (res.status == 422) {
            if (res.data.errors) {
                for(let err in res.data.errors) {
                    ElMessage.error({message: res.data.errors[err].join(', ')})
                }
            }
        } else {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
        }
        saving.value = false
    }
</script>
